import { cloneDeep } from 'lodash';

function* stateGenerator(states) {
  for (let i = 0; true; i++) {
    if (i === states.length) i = 0;

    const state = cloneDeep(states[i]);

    yield state;
  }
}

export const states = [
  {
    onlineStatus: 'online',
    onlineStatusAt: 1641979118449,
    cableStatus: 'connected',
    cableStatusAt: 1641979118449,
    session: {
      id: '1116119655889264900',
      type: 'AC-3Ph-ISO15118',
      duration: 900,
      userIdTag: '02AB02F622D5',
    },
  },
  {
    onlineStatus: 'online',
    onlineStatusAt: 1641979118449,
    cableStatus: 'connected',
    cableStatusAt: 1641979118449,
    session: {
      id: '1116119655889264900',
      type: 'AC-3Ph-ISO15118',
      duration: 900,
      userIdTag: '02AB02F622D5',
    },
  },
  {
    onlineStatus: 'online',
    onlineStatusAt: 1641979118449,
    cableStatus: 'connected',
    cableStatusAt: 1641979118449,
    session: {
      id: '1116119655889264900',
      type: 'AC-3Ph-ISO15118',
      duration: 900,
      userIdTag: '02AB02F622D5',
    },
  },
  {
    onlineStatus: 'online',
    onlineStatusAt: 1641979118449,
    cableStatus: 'connected',
    cableStatusAt: 1641979118449,
    session: {
      id: '1116119655889264900',
      type: 'AC-3Ph-ISO15118',
      duration: 900,
      userIdTag: '02AB02F622D5',
    },
  },
  {
    onlineStatus: 'online',
    onlineStatusAt: 1641979118449,
    cableStatus: 'connected',
    cableStatusAt: 1641979118449,
    session: null,
  },
  {
    onlineStatus: 'online',
    onlineStatusAt: 1641979118449,
    cableStatus: 'disconnected',
    cableStatusAt: 1641979118449,
    session: null,
  },
  {
    onlineStatus: 'online',
    onlineStatusAt: 1641979118449,
    cableStatus: 'disconnected',
    cableStatusAt: 1641979118449,
    session: null,
  },
  {
    onlineStatus: 'online',
    onlineStatusAt: 1641979118449,
    cableStatus: 'connected',
    cableStatusAt: 1641979118449,
    session: null,
  },
  null,
  null,
];

export const makeStateGenerator = () => stateGenerator(states);
